export enum EmailTypeEnum {
  BroadcastEmail = 'BroadcastEmail',
  MarketingEmail = 'MarketingEmail',
}
